import { useEffect } from 'react';
import SEOHead from '../../components/base/SEOHead';
import AssessmentNavbar from './components/AssessmentNavbar';
import AssessmentForm from './components/AssessmentForm';
import AssessmentFAQ from './components/AssessmentFAQ';
import Footer from '../home/components/Footer';

export default function AssessmentPage() {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Ana Sayfa",
        "item": "https://tesisguvenlikbelgesi.com.tr/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Ücretsiz Ön Değerlendirme",
        "item": "https://tesisguvenlikbelgesi.com.tr/ucretsiz-on-degerlendirme"
      }
    ]
  };

  useEffect(() => {
    // Add breadcrumb structured data
    let script = document.getElementById('breadcrumb-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'breadcrumb-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(breadcrumbSchema);
  }, []);

  return (
    <>
      <SEOHead
        title="Ücretsiz Ön Değerlendirme | TGB Danışmanlık Başvuru Formu"
        description="Tesis güvenlik belgesi için ücretsiz ön değerlendirme başvurusu yapın. Firmanızın TGB gereksinimlerini analiz edelim ve size özel yol haritası oluşturalım. Hemen başvurun!"
        keywords="ücretsiz ön değerlendirme, TGB başvuru, tesis güvenlik belgesi başvuru, Milli TGB başvuru, NATO TGB başvuru, danışmanlık başvuru formu, TGB analiz"
        canonicalUrl="https://tesisguvenlikbelgesi.com.tr/ucretsiz-on-degerlendirme"
        ogImage="https://public.readdy.ai/ai/img_res/f79c79c44480ffc60c9bc29047256da6.jpg"
      />

      <div className="min-h-screen bg-white">
        <AssessmentNavbar />
        <AssessmentForm />
        <AssessmentFAQ />
        <Footer />
      </div>
    </>
  );
}